module.exports = __webpack_public_path__ + "img/p67-xiamen-2018.19652b5d.jpg";